import type { QueryClient } from '@tanstack/react-query';
import { bankQueryRoot } from '../../../../shared/api/index.js';

export const refreshAfterUnlink = async (queryClient: QueryClient): Promise<void> => {
  await queryClient.invalidateQueries({ queryKey: bankQueryRoot.all() });
};
